/*
 * share.ts — Phase 12 + V2 #3 version prefix for forward-compatible payloads.
 */
import LZString from 'lz-string'

export const SHARE_MAX_BYTES = 64 * 1024
/** Prefix on lz-string fragments so future format changes can branch safely. */
export const SHARE_PREFIX = '~1~'

export type EncodeResult =
  | { ok: true; fragment: string }
  | { ok: false; reason: 'too-large'; bytes: number }

export function encodeShare(source: string): EncodeResult {
  const bytes = new TextEncoder().encode(source).length
  if (bytes > SHARE_MAX_BYTES) return { ok: false, reason: 'too-large', bytes }
  const compressed = LZString.compressToEncodedURIComponent(source)
  const fragment = `${SHARE_PREFIX}${compressed}`
  return { ok: true, fragment }
}

export function decodeShare(fragment: string): string | null {
  if (!fragment) return null
  const payload = fragment.startsWith(SHARE_PREFIX)
    ? fragment.slice(SHARE_PREFIX.length)
    : fragment
  try {
    const out = LZString.decompressFromEncodedURIComponent(payload)
    return out || null
  } catch {
    return null
  }
}

export function readShareFromUrl(): string | null {
  const hash = window.location.hash
  const matched = hash.match(/[#&]s=([^&]+)/)
  if (!matched) return null
  return decodeShare(matched[1]!)
}

export function buildShareUrl(source: string): string | null {
  const enc = encodeShare(source)
  if (!enc.ok) return null
  const url = new URL(window.location.href)
  url.hash = `s=${enc.fragment}`
  return url.toString()
}
